import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import getTargetName from 'services/forms/getTargetName';
import getTargetValue from 'services/forms/getTargetValue';
import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import TextInputField from 'components/layout/forms/TextInputField';
import translations from 'services/translations/translations';
import { addMessage } from 'store/messages/actions';

import getDefaultWall from '../services/getDefaultWall';
import WallTypeInput from '../src/wallProperties/WallTypeInput';

import 'style/layout/Forms.css';

const AddWall2Connections = ({
  selectedDot,
}: {
  selectedDot: any;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [wall, setWall] = useState(getDefaultWall());

  const restartFields = () => {
    setWall(getDefaultWall());
  };

  const handleWall = (e: any) => {
    setWall({
      ...wall,
      [getTargetName(e)]: getTargetValue(e),
    });
  };

  const addWall2Connections = () => {
    if (!selectedDot) {
      dispatch(
        addMessage(t(`${translations.common}:Modal Messages.Starting Point`))
      );

      return;
    }

    window.AddBetweenTwoConnections(wall);
    restartFields();
    setStep(2);
  };

  useEffect(() => {
    if (selectedDot !== undefined && step === 0) {
      setStep(1);
    }
  }, [selectedDot]);

  return (
    <>
      {step === 0 ? (
        <div className="instructions-text">
          <p>{t(`${translations.common}:Modal Messages.Starting Point`)}</p>
        </div>
      ) : null}
      {step === 1 || step === 2 ? (
        <div className={step === 2 ? 'hidden' : undefined}>
          <Row>
            <Col>
              <WallTypeInput handleWall={handleWall} wall={wall} />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInputField
                id="thickness"
                label={t(`${translations.common}:Wall Properties.Thickness`)}
                onChange={handleWall}
                value={wall.thickness}
                name="thickness"
                required
              />
            </Col>
            <Col>
              <TextInputField
                id="roofHeight"
                label={t(`${translations.common}:Wall Properties.Roof Height`)}
                onChange={handleWall}
                value={wall.roofHeight}
                name="roofHeight"
                required
              />
            </Col>
          </Row>
          <PrimaryButton onClick={addWall2Connections} className="full-width">
            {t(`${translations.common}:Add`).toLocaleUpperCase()}
          </PrimaryButton>
        </div>
      ) : null}
      {step === 2 ? (
        <div className="instructions-text">
          <p>{t(`${translations.common}:Modal Messages.Choose Second Dot`)}</p>
        </div>
      ) : null}
    </>
  );
};

export default AddWall2Connections;
